// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.properties.RentalManagerUserPropertyDetailsWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { GetUserPropertyDetailsResponseWebDto, GetUserPropertyOverviewResponseWebDto, ListingAlias } from '../..';

interface DetailsParams {
  includeAverageDescriptionLength?: boolean;
  includeDeliveryMethod?: boolean;
  includeHasVrModels?: boolean;
  includeTopDupesDetails?: boolean;
  includeVrModels?: boolean;
  includeWebAnalytics?: boolean;
  listingAlias: ListingAlias;
}
interface OverviewParams {
  includeRestrictions?: boolean;
  listingAlias: ListingAlias;
  useUpliftBrainTestData?: boolean;
}

export const RentalManagerUserPropertyDetailsWebApiHandler_details_Path = '/api/web/v1/users/properties/details';

/**
 * Get property details
 */
export const RentalManagerUserPropertyDetailsWebApiHandler_details = (
  getParams: DetailsParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<DetailsParams, never, GetUserPropertyDetailsResponseWebDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyDetailsWebApiHandler_details_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyDetailsWebApiHandler_overview_Path = '/api/web/v1/users/properties/overview';

/**
 * Get property details overview
 */
export const RentalManagerUserPropertyDetailsWebApiHandler_overview = (
  getParams: OverviewParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<OverviewParams, never, GetUserPropertyOverviewResponseWebDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyDetailsWebApiHandler_overview_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};
